<template>
    <InertiaHead>
        <link rel="icon" :href="favicon" type="image/x-icon" />
    </InertiaHead>
    <ThePublicNavigationDrawer />
    <v-main class="align-start justify-center">
        <slot />
    </v-main>
</template>
<script setup lang="ts">
import favicon from '@shared/assets/images/favicon.ico';
</script>
